<template lang="html">
  <div class="login-screen">
    <div class="loader-wrapper">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
  // App.vue swaps layouts when the auth state flips, which remounts this
  // component mid-exchange; the guard stops the second mount from re-sending
  // the one-time code.
  let exchangedCode = null;

  export default {
    name: 'sso-callback',
    created() {
      const hash = window.location.hash.replace(/^#/, '');
      const params = new URLSearchParams(hash);
      const code = params.get('code');

      if (!code) {
        this.$router.replace({ name: 'login', query: { error: 'sso_failed' } });
        return;
      }

      if (code === exchangedCode) {
        return;
      }
      exchangedCode = code;

      this.$store.dispatch('user/user/ssoLogin', code).then((user) => {
        if (user) {
          this.$router.replace({ name: 'dashboard' });
          this.$store.dispatch('user/user/checkAuth', user);
        } else {
          this.$router.replace({ name: 'login', query: { error: 'sso_failed' } });
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/login/SsoCallback.vue